<template>
  <q-card flat>
    <q-form greedy autofocus @submit="onSubmit" @reset="onReset">
      <q-card-section class="no-padding">
        <q-banner class="bg-primary text-white" inline-actions>
          صدور بارنامه
          <template v-slot:action>
            <q-btn round flat icon="close" @click="closeDialog"/>
          </template>
        </q-banner>
      </q-card-section>
      <q-card-section class="q-pa-xs">
        <q-btn round @click="driverAddedDialog=true" color="blue-grey" class="q-mb-sm" text-color="white"
               icon="group_add">
          <q-tooltip>
            افزودن راننده جدید
          </q-tooltip>
        </q-btn>
        <q-btn round color="blue-grey" class="q-mb-sm q-ml-xs" text-color="white" icon="shopping_basket">
          <q-badge color="red" text-color="white" :label="record.orderList.length" floating/>
          <q-tooltip>
            لیست حواله های تشکیل دهنده بارنامه
          </q-tooltip>
          <q-popup-proxy>
            <q-card flat>
              <q-card-section class="no-padding">
                <q-banner class="bg-blue text-white" inline-actions>
                  <span>لیست حواله ها</span>
                  <template v-slot:action>
                    <q-btn icon="close" v-close-popup flat round/>
                  </template>
                </q-banner>
              </q-card-section>
              <q-card-section class="no-padding">
                <div v-for="(item) in record.orderList" :key="item.Sale_num">
                  <q-banner inline-actions class="no-padding">
                    <q-chip square icon="pin" :label="item.Sale_Num">
                      <q-tooltip>
                        شماره حواله
                      </q-tooltip>
                    </q-chip>

                    <q-chip square :label="item.Cs_Name" icon="person"/>
                    <template v-slot:avatar>
                      <q-btn icon="delete" round flat color="red" @click="deleteOrderFromList(item)">
                        <q-tooltip>
                          حذف از لیست
                        </q-tooltip>
                      </q-btn>
                    </template>
                  </q-banner>
                </div>
              </q-card-section>
            </q-card>
          </q-popup-proxy>
        </q-btn>
        <q-btn v-if="$q.screen.lt.md" round color="blue-grey" class="q-mb-sm q-ml-xs" text-color="white" icon="list">
          <q-badge color="red" text-color="white" :label="availableItemsOptions.length" floating/>
          <q-tooltip>
            لیست حواله های تشکیل دهنده بارنامه
          </q-tooltip>
          <q-popup-proxy>
            <q-input :class="$q.screen.lt.md?'q-mt-sm':'q-ml-md'" type="search" filled v-model="filter" label="جستجو"/>
            <q-card flat>
              <q-card-section class="no-padding">
                <q-banner class="bg-blue text-white" inline-actions>
                  <span>لیست حواله ها</span>
                  <template v-slot:action>
                    <q-btn icon="close" v-close-popup flat round/>
                  </template>
                </q-banner>
              </q-card-section>
              <q-card-section>
                <div v-for="(item) in availableItemsOptions" :key="item.Sale_Num">
                  <q-btn icon="add" round flat color="teal" @click="add(item)">
                    <q-tooltip>
                      افزودن به لیست
                    </q-tooltip>
                  </q-btn>
                  <q-chip square icon="pin" :label="item.Sale_Num">
                    <q-tooltip>
                      شماره حواله
                    </q-tooltip>
                  </q-chip>
                  <q-chip square :label="item.Cs_Name" icon="person"/>
                </div>
              </q-card-section>
            </q-card>
          </q-popup-proxy>
        </q-btn>

        <q-btn color="indigo" :class="$q.screen.lt.md?'float-right q-mr-sm':'float-right'" text-color="white"
               v-if="(record.orderList && record.orderList.length>0) || $store.state.roles.some(v=>['admin','can_issue_way_bill_others'].includes(v))"
               label="تایید" icon="check" type="submit"/>
        <q-btn color="red" class="float-right q-mr-xs" flat icon="cancel" label="انصراف" @click="closeDialog"/>
      </q-card-section>
      <q-card-section class="q-pa-xs">
        <div class="row">
          <div class="col-xs-12 col-md-3">
            <q-input dir="ltr" filled v-model="record.transferDate" mask="date" :rules="['date']" hide-bottom-space
                     label="تاریخ حرکت خودرو" clearable readonly class="q-mb-xs">
              <template v-slot:append>
                <q-icon name="event" class="cursor-pointer">
                  <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
                    <q-date v-model="record.transferDate" calendar="persian">
                      <div class="row items-center justify-center">
                        <q-btn v-close-popup label="تایید" color="primary" flat/>
                        <q-btn v-close-popup @click="record.transferDate = ToJalaliDate(new Date())" label="امروز"
                               color="primary"
                               flat/>
                      </div>
                    </q-date>
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
            <q-input filled v-model="record.transferTime" type="time"
                     label="زمان ارسال بار" clearable step="2" class="q-mb-xs"/>
            <q-field
                filled
                v-model="record.transferCost"
                mask="currency"
                label="مبلغ پرداختی به راننده"
                label-color="indigo"
                autofocus
                dir="ltr"
                hide-bottom-space
                class="q-mb-xs"
                lazy-rules
                :rules="[
                val => val.toString().replaceAll(',','') !== null && val.toString().replaceAll(',','') !== '' || 'مبلغ پرداختی به راننده را وارد نمایید',
                val => parseInt(val.toString().replaceAll(',','')) >= 0   || 'مبلغ پرداختی به راننده عددی بزرگتر صفر می باشد، لطفا اصلاح نمایید'
            ]">
              <template v-slot:control="{ id, floatingLabel, value, emitValue }">
                <input :id="id" class="q-field__native text-right" :value="value"
                       @change="e => emitValue(e.target.value)"
                       v-money="moneyFormatForDirective"
                       v-show="floatingLabel">
              </template>
            </q-field>
            <q-select
                filled
                hide-bottom-space
                class="q-mb-xs"
                v-model="record.visitorId"
                label="انتخاب راننده"
                :options="visitorListOptions"
                option-label="Visitor_Name"
                option-value="Visitor_ID"
                @filter="filterFnVisitor"
                use-chips
                use-input
                :rules="[requireRole]">
              <template v-slot:prepend>
                <q-icon name="person"/>
              </template>
            </q-select>
            <q-input
                class="q-mb-xs"
                filled
                dir="ltr"
                autogrow
                v-model="record.POSNo"
                label="شماره POS"/>
            <q-input
                class="q-mb-xs"
                dir="ltr"
                filled
                autogrow
                v-model="record.POSNo"
                label="شماره پایانه"/>
            <q-input
                class="q-mb-xs"
                dir="ltr"
                filled
                autogrow
                v-model="record.POSNo"
                label="شماره حساب"/>
            <q-input
                filled
                autogrow

                v-model="record.title"
                type="textarea"
                label="شرح مختصر">
            </q-input>
          </div>
          <div class="col-xs-12 col-md-5" v-if="!$q.screen.lt.md">
            <q-input :class="$q.screen.lt.md?'q-mt-sm':'q-ml-md'" type="search" filled v-model="filter" label="جستجو"/>
            <div v-for="(item) in availableItemsOptions" :key="item.Sale_Num">
              <q-banner inline-actions>
                <q-chip square icon="pin" :label="item.Sale_Num">
                  <q-tooltip>
                    شماره حواله
                  </q-tooltip>
                </q-chip>
                <q-chip square :label="item.Cs_Name" icon="person"/>
                <template v-slot:action>
                  <q-btn icon="add" round flat color="teal" @click="add(item)">
                    <q-tooltip>
                      افزودن به لیست
                    </q-tooltip>
                  </q-btn>
                </template>
              </q-banner>
            </div>
          </div>
        </div>

      </q-card-section>
    </q-form>
    <q-dialog v-model="driverAddedDialog">
      <DriverInfo :driver-info="null" @driver-added="driverAdded"/>
    </q-dialog>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import DriverInfo from "@/components/Driver/DriverInfo";

export default {
  name: "IssueWayBill",
  components: {DriverInfo},
  props: {
    title: {
      type: String,
      required: true
    },
    ID: {
      type: String,
      required: false
    },
    availableItems: {
      type: [],
      required: true
    }
  },
  data() {
    return {
      driverAddedDialog: false,
      availableItemsOptions: this.availableItems,
      filter: '',
      moneyFormatForDirective: {
        decimal: '.',
        thousands: ',',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      },
      record: {
        id: '',
        visitorId: null,
        title: '',
        transferDate: '',
        transferTime: '',
        transferCost: 0,
        orderList: [],
        POSNo: '',
        TerminalNo: '',
        AccountNo: ''
      },
      visitorList: [],
      visitorListOptions: []
    }
  },
  methods: {
    ...mapActions({
      setAvailableVisitorList: 'Orders/readAvailableVisitors',
      setWayBill: 'Orders/setWayBill'
    }),
    driverAdded(args) {
      this.visitorList.push(args)
      this.$q.notify({
        type: 'positive',
        color: 'positive',
        position: 'top',
        message: 'اطلاعات راننده ثبت گردید'
      })
      this.driverAddedDialog = false
    },
    closeDialog() {
      this.record.orderList.forEach((rec) => {
        this.deleteOrderFromList(rec)
      })
      this.$emit('close-dialog');
    },
    filterFnVisitor(val, update) {
      if (val === '') {
        update(() => {
          this.visitorListOptions = this.visitorList
        })
        return
      }
      update(() => {
        this.visitorListOptions = this.visitorList.filter(v => v.Visitor_Name.indexOf(val) > -1)
      })
    },
    onSubmit() {
      if (this.record.transferTime && this.record.transferTime === '00:00:00') {
        this.$q.notify({
          type: 'negative',
          color: 'negative',
          position: 'top',
          message: 'زمان ارسال بار الزامی است'
        })
      } else {
        this.record.id = this.ID === undefined ? '' : this.ID
        if (this.record.id === '') {
          this.record.orderList.forEach((record) => {
            delete record.GoodsGroup
          });
          this.setWayBill(this.record).then(() => {
            this.$emit('close-dialog');
          })
        }
      }
    },
    onReset() {
    },
    add(item) {
      this.record.orderList.push(item)
      const founded = this.availableItems.findIndex(current => current.Sale_Num === item.Sale_Num)
      this.$delete(this.availableItems, founded)
    },
    deleteOrderFromList(item) {
      this.record.orderList = this.record.orderList.filter(record => record.Sale_Num !== item.Sale_Num);
      this.availableItems.push(item);
    },
    requireRole(val) {
      if (val === null || val === undefined || val === '') {
        return 'انتخاب الزامی است'
      }
    },
    search(list, searchString) {
      return list.filter(element => {
        if (JSON.stringify(element).indexOf(searchString) !== -1) {
          return true;
        }
      })
    }
  },
  watch: {
    filter: function (val) {
      if (val.length === 0) {
        this.availableItemsOptions = this.availableItems
      } else {
        this.availableItemsOptions = this.search(this.availableItems, val)
      }
    }
  },
  created() {
    this.setAvailableVisitorList().then((res) => {
      this.visitorList = eval(res.data.visitors)
      this.visitorListOptions = this.visitorList;
    })
  }
}
</script>

<style scoped>

</style>